<template>
  <Dialog
    :visible.sync="showDialog"
    :showClose="false"
    :title="$t('game.maintain')"
    @touchmove.native.prevent
  >
    <!-- 维护公告 -->
    <div class="maintainContent" @touchmove.stop v-touchmove>
      {{ maintain_data.maintain_notice }}
    </div>
    <!-- 结束时间倒计时 -->
    <i18n
      path="notice.maintain"
      tag="div"
      class="maintainContentTime"
      v-if="!showreload && maintain_data.show_maintain_time"
    >
      <span place="time" class="medium">{{ countdown | formatTime }} </span>
    </i18n>
    <!--  刷新描述文本  -->
    <div class="maintainContentBtn medium" v-if="showreload" @click="confirm()">
      {{ $t('btn.enter') }}
    </div>
  </Dialog>
</template>

<script>
export default {
  name: 'WebVipMaintain',
  props: ['maintain_data'],
  data() {
    return {
      showDialog: true,
      countdown: 0,
      timer: null,
      showreload: false,
    }
  },
  created() {
    // 检查是否有维护结束时间
    if (!this.maintain_data.maintain_end_time) {
      this.showreload = true
      return
    }

    this.countdown = this.maintain_data.maintain_end_time - this.maintain_data.now_time
    this.timer = setInterval(this.updateCountdown, 1000) // 每秒更新
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    confirm() {
      window.location.reload(true)
    },
    updateCountdown() {
      this.countdown--
      if (this.countdown <= 0) {
        this.countdown = 0
        clearInterval(this.timer)
        this.timer = null
        this.showreload = true
      }
    },
  },
}
</script>
<style scoped>
.maintainContent {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #62676b;
  background: #f2f4f8;
  padding: 8px 12px;
  min-height: 160px;
  max-height: 300px;
  background: rgba(242, 244, 248, 1);
  overflow-y: auto;
  box-sizing: border-box;
  margin-bottom: 18px;
  border-radius: 8px;
  white-space: pre-line;
}
.maintainContentTime {
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 400;
}
.maintainContentTime span {
  color: #19b05a;
  font-weight: 600;
  margin: 0 5px;
}
.maintainContentBtn {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  color: #fff;
  background-color: #19b05a;
  border-radius: 8px;
}
</style>
